import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.gps-logger-mapping-item-form', () => {
  void import('./internal/gps-logger-mapping-item-form')
    .then(({ default: Component }) => Component());
});
